import ThreeDotMenu from "app/components/threeDotMenu";
import { VIDEO_SOURCE } from "app/views/company/constants";
import { COMMON_ACCESS_ACTION } from "../../../../../../../../constants";
import { showAlertBox } from "middleware/actions/alertBoxAction";
import { setProductDetails } from "middleware/actions/productAction";
import { actionError, actionSuccess } from "middleware/actions/utilityAction";
import { deleteProductVideo, fetchProductBasicById } from "middleware/services/productApi";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { accessRightActionCheck } from "utilities";
import { Box } from "@mui/material";

const VideosTable = (props) => {
  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);
  const [sortedVideosList, setSortedVideosList] = useState(props?.videosList || []);
  const dispatch = useDispatch();
  const history = useHistory();
  const split_url = props.location.pathname.split("/");
  split_url.pop();
  const { accessRights: aR } = props;

  /* Interface action access from common access */
  useEffect(() => {
    let interfaceName = "Overview";
    let actionAccess = accessRightActionCheck(aR.moduleName, interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, []);

  /* Common access */
  const accessPermissionEdit = interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.EDIT_VIDEOS);
  const accessPermissionDelete = interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.DELETE_VIDEOS);

  const getProductDetails = async () => {
    try {
      const response = await fetchProductBasicById(props?.productId);
      if (response?.data?.data) dispatch(setProductDetails(response.data.data));
    } catch (error) {
      dispatch(actionError("Something Went Wrong while processing."));
    }
  };

  const handleDeleteVideo = async (id) => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          await deleteProductVideo(props?.productId, id).catch((err) => {
            dispatch(actionError(err.data.message || "Something went wrong."));
          });
          dispatch(actionSuccess("Video deleted successfully."));
          await getProductDetails();
        },
      })
    );
  };

  // Sort videosList by latest modified or created date (descending)
  const sortVideosList = () => {
    const sortedList = (props?.videosList || []).slice().sort((a, b) => {
      const dateA = new Date(a?.videoModifiedDate || a?.videoCreatedDate);
      const dateB = new Date(b?.videoModifiedDate || b?.videoCreatedDate);
      return dateB - dateA;
    });
    setSortedVideosList(sortedList);
  };

  useEffect(() => {
    if (props?.videosList?.length > 0) {
      sortVideosList();
    } else {
      setSortedVideosList([]);
    }
  }, [props?.videosList]);

  return (
    <Box>
      {sortedVideosList?.length > 0 && (
        <table className="normal-table table border mb-0">
          <thead className="internal-grid">
            <tr>
              <th style={{ width: "30%" }}>Title</th>
              <th style={{ width: "10%" }}>Duration (Minutes)</th>
              <th style={{ width: "8%" }}>Video Source</th>
              <th style={{ width: "15%" }}>Link</th>
              <th style={{ width: "30%" }}>Video ID</th>
              <th className="internal-grid-action text-center" style={{ borderLeft: "1px solid #dee2e6", width: "5%" }}>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedVideosList.map((item) => {
              return (
                <tr key={`prod-doc-${item.id}`}>
                  <td
                    style={{
                      wordWrap: "break-word",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "0",
                    }}
                  >
                    {item?.videoTitle}
                  </td>
                  <td>{item?.videoDuration}</td>
                  <td>{item?.videoSource}</td>
                  <td>{VIDEO_SOURCE[item?.videoSource]}</td>
                  <td
                    style={{
                      wordWrap: "break-word",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "0",
                    }}
                  >
                    {item?.videoId}
                  </td>
                  <td className="text-center" style={{ borderLeft: "1px solid #dee2e6" }}>
                    {accessPermissionEdit || accessPermissionDelete ? (
                      <ThreeDotMenu
                        rowID={item.id}
                        Edit={
                          accessPermissionEdit
                            ? () => {
                                setTimeout(() => {
                                  history.push(`${split_url.join("/")}/video/${item.id}/edit#overview`, {
                                    companyId: props?.companyId,
                                    productId: props?.productId,
                                    videoId: item.id,
                                  });
                                }, 10);
                              }
                            : undefined
                        }
                        Delete={
                          accessPermissionDelete
                            ? () => {
                                handleDeleteVideo(item.id);
                              }
                            : undefined
                        }
                      />
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Box>
  );
};

export default VideosTable;
